import styled from 'styled-components';

export const Content = styled.div`
  height: 430px;
  overflow: hidden;
`;
